<template>
  <div class="px-10">
    <div class="flex flex-col mt-10">
      <h1 class="border-b-2 border-beige-academy-300 pb-1 text-lg flex justify-start
      font-medium w-full mb-5">
        {{ $t('settings.title') }}
      </h1>
      <div for="preavviso" class="w-full mb-2 font-sans-serif">
        {{ $t('settings.deadline') }}<br>
        {{ $t('settings.deleted') }} <br>
      </div>
      <ul class="flex flex-col items-start w-full font-sans-serif">
        <li class="flex items-center">
          <input type="radio" id="12" v-model="bookingDeadline" :value="12"/>
          <label for="12" class="text-beige-academy-400 font-bold pl-2 pb-1">
            12 {{ $t('settings.hours') }}</label>
        </li>
        <li class="flex items-center">
          <input type="radio" id="24" v-model="bookingDeadline" :value="24"/>
          <label for="24" class="text-beige-academy-400 font-bold pl-2 pb-1">
            24 {{ $t('settings.hours') }}</label>
        </li>
        <li class="flex items-center">
          <input type="radio" id="48" v-model="bookingDeadline" :value="48"/>
          <label for="48" class="text-beige-academy-400 font-bold pl-2 pb-1">
            48 {{ $t('settings.hours') }}</label>
        </li>
        <li class="flex items-center">
          <input type="radio" id="168" v-model="bookingDeadline" :value="168"/>
          <label for="168" class="text-beige-academy-400 font-bold pl-2 pb-1">
            {{ $t('settings.week') }}
          </label>
        </li>
        <li class="flex items-center">
          <input type="radio" id="custom_b" v-model="bookingDeadline" :value="0"/>
          <label for="custom_b" class="text-beige-academy-400 font-bold pl-2 pb-1">
              {{ $t('settings.other') }}:
          </label>
          <input type="number" v-model="customBookingDeadline" :disabled="bookingDeadline !== 0"
            class="bg-beige-academy-200 mx-4 px-2 text-backgound-academy font-bold
            border border-beige-academy-300">
        </li>
      </ul>
      <button class="bg-orange-academy-300 text-white px-4 py-1 rounded border mt-5
        hover:bg-white hover:text-orange-academy-300 w-32 border-orange-academy-300
        font-sans-serif"
         v-if="bookingDeadline!==user.teacher.booking_deadline && !(bookingDeadline ===0 &&
         customBookingDeadline === user.teacher.booking_deadline)"
         @click="saveBookingDeadline">
          {{ $t('settings.save') }}
      </button>
    </div>
    <div class="flex flex-col mt-16">
      <h1 class="border-b-2 border-beige-academy-300 pb-1 text-lg flex justify-start
      font-medium w-full mb-5">
        {{ $t('settings.cancel') }}
      </h1>
      <div for="preavviso" class="w-full mb-2 font-sans-serif">
        {{ $t('settings.selectDeadline') }}<br>
        {{ $t('settings.payment') }} <br>
      </div>
      <ul class="flex flex-col items-start w-full font-sans-serif">
        <li class="flex items-center" v-for="hour in hours" :key="'c'+hour">
          <input type="radio" :id="'c_'+hour" v-model="cancellationDeadline" :value="hour"/>
          <label :for="'c_'+hour" class="text-beige-academy-400 font-bold pl-2 pb-1"
            v-if="hour !== 168">
            {{ hour }} {{ $t('settings.hours') }}
          </label>
          <label :for="'c_'+hour" class="text-beige-academy-400 font-bold pl-2 pb-1" v-else>
            {{ $t('settings.week') }}
          </label>
        </li>
        <li class="flex items-center">
          <input type="radio" id="custom_c" v-model="cancellationDeadline" :value="0"/>
          <label for="custom_c" class="text-beige-academy-400 font-bold pl-2 pb-1">
              {{ $t('settings.other') }}:
          </label>
          <input type="number" v-model="customCancellationDeadline"
            :disabled="cancellationDeadline !== 0"
            class="bg-beige-academy-200 mx-4 px-2 text-backgound-academy font-bold
            border border-beige-academy-300">
        </li>
      </ul>
      <button class="bg-orange-academy-300 text-white px-4 py-1 rounded border mt-5
        hover:bg-white hover:text-orange-academy-300 w-32 border-orange-academy-300
        font-sans-serif"
         v-if="cancellationDeadline!==user.teacher.cancellation_deadline
         && !(cancellationDeadline === 0 &&
         customCancellationDeadline === user.teacher.cancellation_deadline)"
         @click="saveCancellationDeadline">
          {{ $t('settings.save') }}
      </button>
    </div>
    <div class="flex flex-col mt-20">
      <h1 class="border-b-2 border-beige-academy-300 pb-1 text-lg flex justify-start
      font-medium w-full mb-5">
        {{ $t('settings.languages') }}
      </h1>
      <div for="preavviso" class="w-full mb-2 font-sans-serif">
        {{ $t('settings.setLanguages') }} <br>
      </div>
      <div class="flex flex-col w-full">
        <div v-for="lang in languages" :key="lang.code"
        class="flex items-center justify-between mt-3">
          <span
            class="border-b-2 w-full p-2 uppercase border-grey-academy-150
            bg-beige-academy-200">
            {{ lang.name }}
          </span>
          <button class="hover:text-beige-academy-300" @click="deleteLang(lang.code)">
            <bin-icon class="w-4 ml-2" />
          </button>
        </div>
        <div class="flex justify-between items-start mt-3">
          <auto-suggest-language @selected="langSelected($event)" />
          <button class="bg-orange-academy-300 text-white p-1 rounded border ml-5
          hover:bg-white hover:text-orange-academy-300 w-32 border-orange-academy-300
          font-sans-serif"
          @click="saveLanguage">
            {{ $t('settings.save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateTeacherData } from '@/services/TeacherService';
import AutoSuggestLanguage from '../AutoSuggestLanguage.vue';
import BinIcon from '../graphics/BinIcon.vue';

export default {
  components: { AutoSuggestLanguage, BinIcon },

  data() {
    return {
      bookingDeadline: null,
      customBookingDeadline: null,

      cancellationDeadline: null,
      customCancellationDeadline: null,

      hours: [12, 24, 48, 168],

      newLang: '',
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    languages() {
      return this.user.teacher.languages ? JSON.parse(this.user.teacher.languages) : [];
    },
  },

  mounted() {
    this.bookingDeadline = this.user.teacher.booking_deadline;
    if (this.user.teacher.booking_deadline
    && !this.hours.find((hours) => hours === this.bookingDeadline)) {
      this.customBookingDeadline = this.bookingDeadline;
      this.bookingDeadline = 0;
    }
    this.cancellationDeadline = this.user.teacher.cancellation_deadline;
    if (this.user.teacher.cancellation_deadline
    && !this.hours.find((hours) => hours === this.cancellationDeadline)) {
      this.customCancellationDeadline = this.cancellationDeadline;
      this.cancellationDeadline = 0;
    }
  },

  methods: {
    langSelected(lang) {
      this.newLang = lang.item;
    },

    saveBookingDeadline() {
      this.updateData({
        booking_deadline: this.bookingDeadline === 0
          ? this.customBookingDeadline : this.bookingDeadline,
      });
    },

    saveCancellationDeadline() {
      this.updateData({
        cancellation_deadline: this.cancellationDeadline === 0
          ? this.customCancellationDeadline : this.cancellationDeadline,
      });
    },

    saveLanguage() {
      const locales = this.languages;
      if (locales.some((item) => item.code === this.newLang.code)) {
        this.createNotification('warning', this.$t('settings.languageAlreadyExist'));
        return;
      }

      locales.push({
        code: this.newLang.code,
        name: this.newLang.nativeName,
      });
      this.updateData({ languages: JSON.stringify(locales) });
    },

    deleteLang(code) {
      const locales = this.languages.filter((lang) => lang.code !== code);
      this.updateData({ languages: JSON.stringify(locales) });
    },

    updateData(data) {
      updateTeacherData(this.user.teacher.id, data).then(() => {
        this.createNotification('success', this.$t('skills.success'));
        this.$store.dispatch('auth/auth');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
